import {
  Animation,
  Button,
  Flex,
  Header,
  ShareGenericIcon,
} from "@fluentui/react-northstar";
import FluentUINorthstarProvider from "components/wrapped/FluentUINorthstarProvider";
import { appInsights } from "libs/app-insights";
import { TranslationKey } from "libs/locale/i18nLanguages";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { coldStartContextState } from "states/app";
import { rnsThemeState } from "states/fluent-ui";
import { RnsIconSizeCustom } from "styles/rns-custom";

export default function SplashScreen() {
  const rtThemeName = useRecoilValue(rnsThemeState);
  const coldStartContext = useRecoilValue(coldStartContextState);

  const startTime = useRef<number>(Date.now());

  const { t } = useTranslation();

  function handleRefresh() {
    // 스플레시 스크린에서 어느정도까지 기달리다가 새로고침을 누르는지 알기 위함
    const endTime = Date.now();
    appInsights.trackEvent({
      name: "SplashScreenRefresh",
      properties: {
        Href: window.location.href,
        Pathname: window.location.pathname,
        Search: window.location.search,
        InfoMessage: coldStartContext,
        Duration: endTime - startTime.current,
      },
    });
    // window.location.reload(); 으로 새로고침 시도 시 에러가 발생한 url 그래도 새로고침되어 계속 에러가 발생한 queryString으로 돌아오므로 queryString을 제거하여 새로고침 하도록 합니다.
    window.location.href = window.location.href.split("?")[0];
  }

  return (
    <>
      <FluentUINorthstarProvider>
        <Flex fill column vAlign="center" hAlign="center" gap="gap.medium">
          <Animation name="slideDownEnterUltraSlow">
            <RnsIconSizeCustom size={100}>
              <ShareGenericIcon
                style={{
                  color:
                    rtThemeName.siteVariables.colorScheme.default.foreground1,
                }}
              />
            </RnsIconSizeCustom>
          </Animation>
          <Animation
            name="fadeEnterUltraSlow"
            delay="3s"
            duration="2s"
            fillMode="backwards"
          >
            <Header as="h3" content={t(coldStartContext)} />
          </Animation>
          <Animation
            name="fadeEnterUltraSlow"
            delay="5s"
            duration="2s"
            fillMode="backwards"
          >
            <Button
              primary
              content={t(TranslationKey["새로 고침"])}
              onClick={handleRefresh}
            />
          </Animation>
        </Flex>
      </FluentUINorthstarProvider>
    </>
  );
}
